// extracted by mini-css-extract-plugin
export default {"detail_taps":"DetailTaps_detail_taps__jQLGl","appear":"DetailTaps_appear__XsJf7","tap_btn":"DetailTaps_tap_btn__xF8Rh"};